﻿export interface IRccapAdditionalQuestionRequest {
    id: number;
    question: string;
    answer: string;
    isDeleted: boolean;
}
